var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{attrs:{"columns":_vm.columns,"data":_vm.data},scopedSlots:_vm._u([{key:"money",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_vm._v("\n            ¥ "+_vm._s(row.money)+"元\n        ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }